export const NationalParkList = [
  { value: "1", label: "Yala National Park Block 01" },
  { value: "2", label: "Yala National Park Block 05" },
];
